import { render, staticRenderFns } from "./DialogEditarCombustivel.vue?vue&type=template&id=460aa924&"
import script from "./DialogEditarCombustivel.vue?vue&type=script&lang=js&"
export * from "./DialogEditarCombustivel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports